export default [
	{
		hash: '9916fd2adaf39d67295e61a5b09e516f',
		link: '/dashboard',
		text: 'Dashboard',
		icon: 'dashboard',
	},

	{
		text: 'Cadastros',
		icon: 'sliders',
		childs: [
			{
				link: '/categories',
				text: 'Categorias',
				hash: '70e0a274e686bae0c5f23402928de706',
			},
			{
				link: '/customers',
				text: 'Empresas',
				hash: '0f77b2fe32a687411a006ed799b30651',
			},
			{
				link: '/collaborators',
				text: 'Colaboradores',
				hash: '0f77b2fe32a687411a006ed799b30651',
			},
			{
				link: '/departments',
				text: 'Departamentos',
				hash: 'a95a4f4f557354b88a1584be334cc63e',
			},
			{
				link: '/managers',
				text: 'Gestores',
				hash: 'ab3c2054793051d1dbd4e6bce6d9acec',
			},
			// {link: "/exames", text: "Exames", hash:"02ddd45060a798d1b0fdcb96185a753d"},
			{
				link: '/regions',
				text: 'Regiões, T/CLiente',
				hash: [
					'45a262f2d277172837aea51fcd6c658b',
					'1bcad1268552bd1cd358eaa48d68d8b4',
				],
			},
			{
				link: '/types-of-proposals',
				text: 'Tipos de Propostas',
				hash: 'a734e1c3f4ec26f30989c6b545049c4f',
			},
			{
				link: '/sellers',
				text: 'Vendedores',
				hash: 'b1b2529fc07ce4a528f907577eb90f1c',
			},

			// {link: "/sst/pacientes", text: "Pacientes"},
			// {link: "/sst/materias", text: "Materias"},
			// {link: "/sst/exames", text: "Exames"},
		],
	},

	{
		text: 'Modelos',
		icon: 'code',
		childs: [
			{
				link: '/documents',
				text: 'Documentos',
				hash: 'b1e8efa09cba33b1245f212c9b40e093',
			},
			{
				link: '/forms',
				text: 'Formulários',
				hash: '548635952bf42e2b90258eb69e21c10d',
			},
			{
				link: '/tasks',
				text: 'Tarefas',
				hash: 'a8d4e813b9a0c8fed96919c59f7c16a2',
			},
		],
	},
	{
		hash: '4a4467ade696428724a47a0f1566194e',
		link: undefined,
		text: 'Serviços',
		icon: 'pie-chart',
		childs: [
			{ link: '/services/sms', text: 'SMS' },
			{ link: '/services/off-shore', text: 'OffShore' },
			{ link: '/services/internal', text: 'Internas' },
			{ link: '/services/app-sst', text: 'App/SST' },
		],
	},

	{
		hash: '37398e0d87d33c912d3fbe125f4f10ed',
		text: 'Smart Tables',
		icon: 'th',
	},

	// {
	//   hash: undefined,
	//   link: undefined,
	//   text: "SD2000",
	//   icon: "language",
	//   childs: [
	//     {link: "/sd2000/linhas", text: "Linhas"},
	//     {link: "/sd2000/exames", text: "Exames"},
	//   ],
	// },

	// {
	//   hash: "4a4467ade696428724a47a0f1566194e",
	//   link: undefined,
	//   text: "SST",
	//   icon: "language",
	//   childs: [
	//     {link: "/sst/petrobras", text: "Petrobras"},
	//     {link: "/dashboard", text: "Clinica"},
	//     {link: "/dashboard", text: "Engenharia"},
	//     {link: "/dashboard", text: "Medicina"},
	//   ],
	// },

	// {
	//   link: undefined,
	//   text: "PETROBRAS",
	//   icon: "upload",
	//   childs: [
	//     // {link: "/sd2000/oportunidades", text: "OPORTUNIDADES ", hash: undefined },
	//     // {link: "/sd2000/pedido_compra", text: "PEDIDO DE COMPRA", hash: undefined },

	//     // {link: "/sd2000/import", text: "IMPORTAR ", hash: undefined },
	//     {link: "/sd2000/solicitacoes", text: "EXAMES", hash: "94813064f4fd94f9553f917602fa996c"},
	//     {link: "/sd2000/extratos", text: "SD2000", hash: "759cdee18bcd89cc47d0315409ffd56f"},
	//   ],
	// },

	{
		link: undefined,
		text: 'Saúde',
		icon: 'clock-o',
		childs: [
			// {link: "/sd2000/oportunidades", text: "OPORTUNIDADES ", hash: undefined },
			// {link: "/sd2000/pedido_compra", text: "PEDIDO DE COMPRA", hash: undefined },

			// {link: "/sd2000/import", text: "IMPORTAR ", hash: undefined },
			{
				link: '/exames_dashboard',
				text: 'Dashboard',
				hash: '9df4cac6c6decdd92a515f1978891c0a',
			},
			{
				link: '/exames',
				text: 'Exames',
				hash: '9df4cac6c6decdd92a515f1978891c0a',
			},
			{
				link: '/vacinas',
				text: 'Vacinas',
				hash: '9df4cac6c6decdd92a515f1978891c0a',
			},

			// {link: "/pessoas",    text: "Pessoas",          hash:"02ddd45060a798d1b0fdcb96185a753d"},
			// {link: "/navios",     text: "Navios",           hash:"02ddd45060a798d1b0fdcb96185a753d"},
			// {link: "/tipo_exame", text: "Tipos de Exame",   hash:"02ddd45060a798d1b0fdcb96185a753d"},
			// {link: "/passaporte", text: "Passaporte",       hash:"02ddd45060a798d1b0fdcb96185a753d"},
			// {link: "/resultados", text: "Resultados",       hash:"02ddd45060a798d1b0fdcb96185a753d"},
			// {link: "/tabelas", text: "Tabelas", hash: "759cdee18bcd89cc47d0315409ffd56f"},
		],
	},

	{
		hash: 'c0705d0703c8c5673a36ff2338aa83d5',
		link: '/proposals',
		text: 'Propostas',
		icon: 'table',
	},
	{
		hash: '19ba76b571b0081fd3b0b2e4b771e71e',
		link: '/contracts',
		text: 'Contratos',
		icon: 'files-o',
	},
	// {
	//   text: "SST",
	//   icon: "warning",
	//   childs: [
	//     {link: "/sst/seguranca", text: "Segurança", hash: "5981f097ef4939cd987e21757e0f67a6"},
	//     // {link: "/sst/saude", text: "Saúde", hash: "9916fd2adaf39d67295e61a5b09e516f"}
	//   ],
	// },
	{
		hash: 'e39d0fe0d38bcf01ef07aed2f645371f',
		link: '/order-of-service',
		text: 'Ordem de Serviço',
		icon: 'clock-o',
	},

	{
		hash: '02ddd45060a798d1b0fdcb96185a753d',
		link: '/supervisao',
		text: 'Supervisão',
		icon: 'clock-o',
		childs: undefined,
	},

	{
		text: 'Configurações',
		icon: 'cogs',
		childs: [
			{
				link: '/perfis',
				text: 'Perfis',
				hash: 'cafbaf96bcb4c0af01ce9ddfbbcf6dbd',
			},
			{
				link: '/users',
				text: 'Usuários',
				hash: 'f28761aec7f41c3cb6f406dc6e3c4de9',
			},
			{
				link: '/app-settings',
				text: 'Config. App',
				hash: '8e81d5f75b4902a77339119de8adc693',
			},
			// {link: "/os-statics", text: "O.S. Estáticas", hash: undefined}
		],
	},
	// {
	// 	hash: undefined,
	// 	link: undefined,
	// 	text: "Cadastros",
	// 	icon: "sliders",
	// 	childs: undefined,
	// },
];



// WEBPACK FOOTER //
// ./src/components/cnt-app/components/mapMenu.js